import { queryClient } from "@/queryClient"
import type { Acquirer } from "../sharedTypes/merchants"
import type { MerchantCurrencyCode } from "@/utils/currency"

export type UpdateMerchantParams = {
  businessName: string

  tpReference: string
  merchantCategoryCode: string | null
  currency: MerchantCurrencyCode

  customerName: string
  customerEmail: string
  customerPhone: string

  addressLine1: string | null
  addressLine2: string | null

  cardstreamMerchantId?: string | null
  cardstreamMerchantSecret?: string | null

  paxMerchantId: string | null
  acquirer: Acquirer
  evoConfig: {
    gratuityIsAvailable: boolean
  }

  hasSalesModule: boolean
  hasDonationsModule: boolean
  hasBeepaidOrderModule: boolean
  hasBeepaidGoModule: boolean

  isFromBackbook: boolean
  isDemoMerchant: boolean
  isActive: boolean
}

export type PrepareUpdateMerchant = {
  id: number
  businessName: string

  // Could theoretically be null because the field is nullable, but we expect it to not be null when doing the update
  tpReference: string
  merchantCategoryCode: string | null
  currency: MerchantCurrencyCode
  canEditCurrency: boolean

  customerName: string
  customerEmail: string
  customerPhone: string

  addressLine1: string | null
  addressLine2: string | null
  cardstreamMerchantId: string | null
  cardstreamMerchantSecret: string | null

  paxMerchantId: string | null
  acquirer: Acquirer
  evoConfig: {
    gratuityIsAvailable: boolean
  }

  hasSalesModule: boolean
  hasDonationsModule: boolean
  hasBeepaidOrderModule: boolean
  hasBeepaidGoModule: boolean

  isFromBackbook: boolean
  isDemoMerchant: boolean
  isActive: boolean
}

export const retrieveMerchantForUpdate = async (
  merchantId: number
) => {
  const { body } = await api.get<PrepareUpdateMerchant>(
    `/merchants/update/${merchantId}/`
  )
  return body
}

export const updateMerchant = async (
  merchantId: number,
  params: UpdateMerchantParams
) => {
  await api.put(`/merchants/${merchantId}/`, {
    body: params,
  })

  queryClient.invalidateQueries({
    queryKey: [MERCHANTS_QUERY_KEY],
  })
  return
}
